<template>
  <div class="flex items-center justify-end text-sm">
    <!-- Displaying the range of items -->
    <div class="text-base-content/80 pr-6">
      {{ meta.from }}-{{ meta.to }} iš {{ meta.total }}
    </div>

    <!-- Previous and Next buttons -->
    <div class="flex">
      <!-- Previous button -->
      <a
        class="pr-6"
        :class="{
          'text-base-content/40 pointer-events-none': pageNumber === 1,
        }"
        @click="getForPage('prev')"
        ><svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-4 h-4 cursor-pointer"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 19.5 8.25 12l7.5-7.5"
          />
        </svg>
      </a>

      <!-- Next button -->
      <a
        :class="{
          'text-base-content/40 pointer-events-none': pageNumber === meta.last_page,
        }"
        @click="getForPage('next')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-4 h-4 cursor-pointer"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m8.25 4.5 7.5 7.5-7.5 7.5"
          />
        </svg>
      </a>
    </div>
  </div>
</template>
<script setup>
import { ref, defineProps } from "vue";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();

const props = defineProps({
  meta: Object,
});

const currentQuery = { ...route.query };
const pageNumber = ref(props.meta.current_page);

function getForPage(link) {
  if (link == "next") {
    pageNumber.value = pageNumber.value + 1;
  } else if (link == "prev") {
    pageNumber.value = pageNumber.value - 1;
  }

  if (link) {
    currentQuery.page = pageNumber.value;
    router.push({
      query: currentQuery,
    });
  }
}
</script>
